export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13094.857caa1f.jpg";